import { createColumnHelper } from "@tanstack/react-table";
import { getStatusBadge } from "../../component/table-utils/get-status-badge";
import React from "react";
import DotsVertical from "../../assets/dotsVertitical";
import { orderData } from ".";
import truncate from "../../lib/utils/truncate";
import TableMenu from "../../component/table-utils/tableMenu";
import formatDate from "../../lib/utils/formatDate";
import getFileFormat from "../../lib/utils/fileName";

export type OrdersDataType = {
  id: string;
  nameGiven: string;
  fileName?: string;
  createdAt: string;
  documentUrl: string;
};
const columnHelper = createColumnHelper<OrdersDataType>();

export const basicColumns = [
  columnHelper.display({
    id: "nameGiven",
    size: 100,
    header: "NAME GIVEN",
    cell: ({ row }) => <>{row.original.nameGiven}</>,
  }),
  columnHelper.display({
    id: "fileName",
    size: 100,
    header: "FILE NAME",
    cell: ({ row }) => <>{row.original.fileName}</>,
  }),
  /*  columnHelper.display({
    id: "fileSize",
    size: 100,
    header: "FILE SIZE",
    cell: ({ row }) => <>{row.original.fileSize}</>,
  }), */
  columnHelper.display({
    id: "fileFormat",
    size: 80,
    header: "FILE FORMAT",
    cell: ({ row }) => <>{getFileFormat(row.original.fileName)}</>,
  }),
  columnHelper.accessor("createdAt", {
    id: "createdAt",
    size: 110,
    header: ({ column }) => (
      <div className="flex items-center gap-1">CREATED AT</div>
    ),
    cell: (info) => <>{formatDate(info.getValue())}</>,
    enableSorting: true,
  }),

  columnHelper.display({
    id: "actions",
    size: 30,
    cell: ({ row }) => (
      <div
        className="w-full flex justify-center"
        onClick={(e) => e.stopPropagation()}
      >
        <TableMenu row={row} page="knowledgebase" />
      </div>
    ),
  }),
];
